var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isEditorX, isADI, isClassicEditor } from '../helpers';
import { ViewerScriptEnvironment, } from './ViewerScript';
var ControllerEnvironment = /** @class */ (function (_super) {
    __extends(ControllerEnvironment, _super);
    function ControllerEnvironment(options) {
        var _this = this;
        var _a;
        _this = _super.call(this, options) || this;
        _this.entry = 'viewerScript';
        var config = options.config, widgetId = options.widgetId, locationAPI = options.locationAPI;
        var query = locationAPI.query;
        _this.isEditorX = isEditorX((_a = config === null || config === void 0 ? void 0 : config.style) === null || _a === void 0 ? void 0 : _a.styleParams);
        _this.isADI = isADI(query);
        _this.isClassicEditor = isClassicEditor(query);
        _this.widgetId = widgetId;
        return _this;
    }
    return ControllerEnvironment;
}(ViewerScriptEnvironment));
export { ControllerEnvironment };
//# sourceMappingURL=Controller.js.map